function focusElement(element: string) {
  const el = document.querySelector<HTMLElement>(element)
  if (!el)
    return
  el.focus()
}

export { focusElement }
